'use strict';

const productImpressionsHandler = require('./eventHandlers/eecHandlers/productImpressions');
const productClicksHandler = require('basePluginGtm/gtm/eventHandlers/eecHandlers/productClicks');
const productDetailsView = require('./eventHandlers/eecHandlers/productDetailsView');
const addToCartHandler = require('./eventHandlers/eecHandlers/addToCart');
const viewCartHandler = require('./eventHandlers/eecHandlers/viewCart');
const removeFromCartHandler = require('./eventHandlers/eecHandlers/removeFromCart');
const checkoutHandler = require('./eventHandlers/eecHandlers/checkout');
const checkoutOptionHandler = require('./eventHandlers/eecHandlers/checkoutOption');
const purchaseHandler = require('./eventHandlers/eecHandlers/purchase');
const internalPromotionImpressionsHandler = require('basePluginGtm/gtm/eventHandlers/eecHandlers/internalPromotionImpressions');
const internalPromotionClicksHandler = require('basePluginGtm/gtm/eventHandlers/eecHandlers/internalPromotionClicks');

const funnelStartsHandler = require('basePluginGtm/gtm/eventHandlers/funnelHandlers/starts');
const funnelStepBackHandler = require('basePluginGtm/gtm/eventHandlers/funnelHandlers/stepBack');
const funnelStepCompletionHandler = require('basePluginGtm/gtm/eventHandlers/funnelHandlers/stepCompletion');
const funnelSuccessHandler = require('basePluginGtm/gtm/eventHandlers/funnelHandlers/success');
const funnelCloseOutHandler = require('basePluginGtm/gtm/eventHandlers/funnelHandlers/closeOut');

//Custom Funnels
const storeLocatorStartHandler = require('basePluginGtm/gtm/eventHandlers/storeLocator/storeLocatorStart');
const storeLocatorSearchHandler = require('basePluginGtm/gtm/eventHandlers/storeLocator/storeLocatorSearch');
const storeLocatorDetailsHandler = require('basePluginGtm/gtm/eventHandlers/storeLocator/storeLocatorDetails');
const storeLocatorDirectionsHandler = require('basePluginGtm/gtm/eventHandlers/storeLocator/storeLocatorDirections');
const storeLocatorSaveHandler = require('basePluginGtm/gtm/eventHandlers/storeLocator/storeLocatorSave');
const storeLocatorRemoveHandler = require('basePluginGtm/gtm/eventHandlers/storeLocator/storeLocatorRemove');


const searchHandler = require('basePluginGtm/gtm/eventHandlers/search/search');
const ajaxResponses = require('./ajaxResponses/index');

//Custom Events
const attachedProductDetailView = require('./attachedEvents/productDetailView');
const attachedProductClick = require('basePluginGtm/gtm/attachedEvents/productClick');
const attachedProductImpressions = require('./attachedEvents/productImpressions');
const attachedCheckout = require('./attachedEvents/checkout');
const attachedStoreLocator = require('basePluginGtm/gtm/attachedEvents/storeLocator');
const attachedRegister = require('basePluginGtm/gtm/attachedEvents/register');
const attachedCTA = require('basePluginGtm/gtm/attachedEvents/cta');
const attachedCart = require('./attachedEvents/cart');
const attachedOrderConfirmation = require('./attachedEvents/orderConfirmation');

// GA4 events
const ga4SearchHandler = require('./eventHandlers/ga4/search/search');
const ga4ProductDetailsView = require('./eventHandlers/ga4/productDetailsView');
const ga4AddToCartHandler = require('./eventHandlers/ga4/addToCart');
const ga4StartCheckouttHandler = require('./eventHandlers/ga4/startCheckout');
const ga4PurchaseHandler = require('./eventHandlers/ga4/purchase');
const ga4CheckoutOptionHandler = require('./eventHandlers/ga4/checkoutOption');
const attachedStartCheckoutView = require('./attachedEvents/startCheckoutView');



const handleBuiltInEvents = () => {
    $('body').on('product:afterAddToCart', function (e, data) {
        $('body').trigger('gtm:eec:addToCart', data);
        $('body').trigger('gtm:ga4:addToCart', data);
    });

    ajaxResponses.handle();
}

const handleCustomEvents = () => {
    attachedProductDetailView.attach();
    attachedProductClick.attach();
    attachedProductImpressions.attach();
    attachedCheckout.attach();
    attachedStoreLocator.attach();
    attachedCTA.attach();
    attachedCart.attach();
    attachedOrderConfirmation.attach();
    attachedStartCheckoutView.attach();

    if ($('#gtm-register').length) attachedRegister.attach();
}

const registerEecEvents = () => {
    $('body').on('gtm:eec:productImpressions', productImpressionsHandler.handle);
    $('body').on('gtm:eec:productClicks', productClicksHandler.handle);
    $('body').on('gtm:eec:productDetailsView', productDetailsView.handle);
    $('body').on('gtm:eec:addToCart', addToCartHandler.handle);
    $('body').on('gtm:eec:viewCart', viewCartHandler.handle);
    $('body').on('gtm:eec:removeFromCart', removeFromCartHandler.handle);
    $('body').on('gtm:eec:checkout', checkoutHandler.handle);
    $('body').on('gtm:eec:checkoutOption', checkoutOptionHandler.handle);
    $('body').on('gtm:eec:purchase', purchaseHandler.handle);

    // GA4 events
    $('body').on('gtm:ga4:viewItemList', ga4SearchHandler.handle);
    $('body').on('gtm:ga4:productDetailsView', ga4ProductDetailsView.handle);
    $('body').on('gtm:ga4:addToCart', ga4AddToCartHandler.handle);
    $('body').on('gtm:ga4:startCheckout', ga4StartCheckouttHandler.handle);
    $('body').on('gtm:ga4:purchase', ga4PurchaseHandler.handle);
    $('body').on('gtm:ga4:checkoutOption', ga4CheckoutOptionHandler.handle);
};

const registerOptionalEecEvents = () => {
    $('body').on('gtm:eec:internalPromotionImpressions', internalPromotionImpressionsHandler.handle);
    $('body').on('gtm:eec:internalPromotionClicks', internalPromotionClicksHandler.handle);
};

const registerFunnelsEvents = () => {
    $('body').on('gtm:funnels:starts', funnelStartsHandler.handle);
    $('body').on('gtm:funnels:success', funnelSuccessHandler.handle);
    $('body').on('gtm:funnels:stepCompletion', funnelStepCompletionHandler.handle);
    $('body').on('gtm:funnels:stepBack', funnelStepBackHandler.handle);
    $('body').on('gtm:funnels:closeOut', funnelCloseOutHandler.handle);
};

const registerCustomFunnels = () => {
    if ($('#gtm-storeLocator-stores').length) {
        $('body').on('gtm:storeLocator:start', storeLocatorStartHandler.handle);
        $('body').on('gtm:storeLocator:search', storeLocatorSearchHandler.handle);
        $('body').on('gtm:storeLocator:searchCompleted', attachedStoreLocator.attachInfo);
        $('body').on('gtm:storeLocator:details', storeLocatorDetailsHandler.handle);
        $('body').on('gtm:storeLocator:directions', storeLocatorDirectionsHandler.handle);
        $('body').on('gtm:storeLocator:save', storeLocatorSaveHandler.handle);
        $('body').on('gtm:storeLocator:remove', storeLocatorRemoveHandler.handle);
    }
}

const registerSearchEvents = () => {
    $('body').on('gtm:search', searchHandler.handle);
};

const configureFooter = () => {
    $('footer a').addClass('ga_footerNav');
};

$(document).ready(() => {
    configureFooter();

    registerSearchEvents();
    registerFunnelsEvents();
    registerCustomFunnels();
    registerEecEvents();
    registerOptionalEecEvents();

    handleBuiltInEvents();
    handleCustomEvents();
});